module.exports = __webpack_public_path__ + "img/haidi_JP.63ffe13e.jpg";